
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ps/[productNames]/[productIds]",
      function () {
        return require("private-next-pages/ps/[productNames]/[productIds].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ps/[productNames]/[productIds]"])
      });
    }
  